import { FaChevronRight } from "react-icons/fa";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import { useNavigate } from "react-router-dom";
import FlashSaleImg from "../../../assets/images/specialoffer.svg";
import PurchaseHeader from "./purchaseComponents/PurchaseHeader";
import PrincipalSwiper from "./purchaseComponents/PrincipalSwiper";
import MostSearchedProductSwiper from "./purchaseComponents/MostSearchedProductSwiper";
import RecentSearchProductSwiper from "./purchaseComponents/RecentSearchProductSwiper";
import SpecialOfferProductSwiper from "./purchaseComponents/SpecialOfferProductSwiper";
import CarouselBanner from "./purchaseComponents/CarouselBanner";
import PopupHome from "./purchaseComponents/PopupHome";
import PurchaseProductList from "./PurchaseProductList";

const PurchaseList = () => {
  const navigate = useNavigate();

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <PurchaseHeader />
      <PopupHome />

      <div className="mt-[70px]">
        {/* <div className="px-3 my-4"> */}
        <CarouselBanner />
        {/* </div> */}

        <div className="px-3 mb-4">
          <div className="flex justify-between items-center mb-2">
            <p className="text-[18px] font-bold">Principal</p>
            <div
              className="flex gap-2 items-center cursor-pointer hover:text-gray-300"
              onClick={() => navigate(`/purchase-pbf/principal`)}
            >
              <p>Lihat Semua</p>
              <FaChevronRight />
            </div>
          </div>

          <PrincipalSwiper />
        </div>

        <div className="bg-[#051462] text-white px-3 py-4 min-h-[50vh] mb-4">
          <div className="flex justify-between items-center mb-2">
            <p className="text-[18px] font-bold">Penawaran Spesial</p>
            <div
              className="flex gap-2 items-center cursor-pointer hover:text-gray-300"
              onClick={() =>
                navigate(`/purchase-pbf/product-list/special-offer`)
              }
            >
              <p>Lihat Semua</p>
              <FaChevronRight />
            </div>
          </div>

          <div className="w-full flex gap-4 items-center">
            <img src={FlashSaleImg} className="w-[200px] md:w-[300px]" />
            <div className="w-[calc(100%-280px)]">
              <SpecialOfferProductSwiper />
            </div>
          </div>
        </div>

        <div className="px-3 mb-4">
          <div className="flex justify-between items-center mb-2">
            <p className="text-[18px] font-bold">Berdasarkan Pencarianmu</p>
            <div
              className="flex gap-2 items-center cursor-pointer hover:text-gray-300"
              onClick={() =>
                navigate(`/purchase-pbf/product-list/recent-search`)
              }
            >
              <p>Lihat Semua</p>
              <FaChevronRight />
            </div>
          </div>

          <RecentSearchProductSwiper />
        </div>

        {/* <div className="px-3 mb-4">
          <div className="flex justify-between items-center mb-2">
            <p className="text-[18px] font-bold">Paling Banyak Dicari</p>
            <div
              className="flex gap-2 items-center cursor-pointer hover:text-gray-300"
              onClick={() => navigate(`/purchase-pbf/product-list/most-search`)}
            >
              <p>Lihat Semua</p>
              <FaChevronRight />
            </div>
          </div>
          <MostSearchedProductSwiper />
        </div> */}

        {/* <div className="px-3 mb-4">
          <button
            type="button"
            className="border-2 rounded-md p-2 bg-[#F1FAF0] border-[#6F955B] text-[#6F955B] w-full hover:bg-gray-200"
            onClick={() => navigate(`/purchase-pbf/product-list/all`)}
          >
            Lihat Semua Produk
          </button>
        </div> */}

        <div className="px-3 mb-4">
          <div className="flex justify-between items-center mb-2">
            <p className="text-[18px] font-bold">Semua Produk</p>
          </div>
          <PurchaseProductList />
        </div>
      </div>
    </div>
  );
};

export default PurchaseList;
